export default {
  methods: {
    getMemberRecords (search, loading) {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (search.length > 2) {
        loading(true)
        pageUrl += 'member?all=all'
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
        if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
          pageUrl += `&agent_id=${c.id}`
        }
        pageUrl += `&name=${search}`
        this.$axios.get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loading(false)
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GetMemberRecordSearch.js